import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import Terms from '../components/terms';
import { useStores } from '@utils/storeProvider';

const PrivacyPage = observer(() => {
  const { termsStore } = useStores();
  const { termsList } = termsStore;

  useEffect(() => {
    termsStore.fetchTermsList('PRIVACY_POLICY');
  }, []);

  return (
    <Layout>
      <Header />
      <Content>
        <Terms title={'개인정보 처리방침'} termsList={termsList} />
      </Content>
      <Footer />
    </Layout>
  );
});

export default PrivacyPage;
